import { render, staticRenderFns } from "./MatrixTable.vue?vue&type=template&id=0629ff62&scoped=true&lang=pug&"
import script from "./MatrixTable.vue?vue&type=script&lang=js&"
export * from "./MatrixTable.vue?vue&type=script&lang=js&"
import style0 from "./MatrixTable.vue?vue&type=style&index=0&id=0629ff62&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0629ff62",
  null
  
)

export default component.exports